/**
 * useCommunityRituals Hook
 * Fetches community rituals with pagination and search using React Query
 */

import { useQuery } from "@tanstack/react-query"
import { getCommunityRituals } from "../services/ritual.service"

interface UseCommunityRitualsOptions {
  page?: number
  limit?: number
  search?: string
  status?: "all" | "archived" | "requests" | "joined"
  enabled?: boolean
}

export function useCommunityRituals(communityId: string, options?: UseCommunityRitualsOptions) {
  return useQuery({
    queryKey: [
      "community-rituals",
      communityId,
      options?.page,
      options?.limit,
      options?.search,
      options?.status,
    ],
    queryFn: () =>
      getCommunityRituals(communityId, {
        page: options?.page,
        limit: options?.limit,
        search: options?.search,
        status: options?.status,
      }),
    enabled: options?.enabled ?? !!communityId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}
